import { render, staticRenderFns } from "./upgradeLog.vue?vue&type=template&id=68cfab19&scoped=true&"
import script from "./upgradeLog.vue?vue&type=script&lang=js&"
export * from "./upgradeLog.vue?vue&type=script&lang=js&"
import style0 from "./upgradeLog.vue?vue&type=style&index=0&id=68cfab19&lang=scss&scoped=true&"
import style1 from "./upgradeLog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cfab19",
  null
  
)

export default component.exports